import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

//Services
import { Usuario } from "../../base/vo/usuario";
import { AutenticacaoService } from "../../autenticacao/autenticacao.service";
import { UsuarioDashboardService } from "./usuario-dashboard.service";
import { error } from 'selenium-webdriver';
import { DadosPrestadorService } from '../../dados-prestador/dados-prestador.service';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
  selector: 'app-usuario-dashboard',
  templateUrl: './usuario-dashboard.component.html',
  styleUrls: ['./usuario-dashboard.component.css']
})
export class UsuarioDashboardComponent implements OnInit {

  usuario: Usuario;
  urlImagemUsuario = null;
  modalAlterarImagemPerfil: boolean;
  urlPreview: any;
  loading:boolean = false;

  file: File;
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(public autenticacaoService: AutenticacaoService,
    public usuarioDashboardService: UsuarioDashboardService,
    public dadosPrestadorService: DadosPrestadorService,
    public messageService: MessageService) { }

  ngOnInit() {
    this.usuario = new Usuario();
    this.carregarDadosUsuarioLogado();
    this.modalAlterarImagemPerfil = false;
    this.loading = false;
  }

  private carregarDadosUsuarioLogado() {
    this.usuario = this.autenticacaoService.usuarioLogado;
    this.urlImagemUsuario = this.dadosPrestadorService.getImgPerfilCached();
  }
  
  exibeModalAlterarImagemPerfil() {
    this.limparModalALterarImagemPerfil();
  	this.modalAlterarImagemPerfil = true;
  }
  
  limparModalALterarImagemPerfil() {
  	this.file = null;
    this.urlPreview = null;
    this.fileInput.nativeElement.value = null;
  }
  
  selecionarArquivo() {
	this.fileInput.nativeElement.click();
  }

  fileChange(e) {
	if(e.target.files.length > 0) {
		this.file = e.target.files[0];
		
		let reader = new FileReader();
		
		reader.onload = (event: any) => {
			this.urlPreview = event.target.result;
		}
		
		reader.readAsDataURL(this.file);
		
	}
  }

  alterarImagemPerfil() {
  	this.loading = true;
    this.usuarioDashboardService
      .alterarImagemPerfil(this.file).subscribe(
        data => {
        	this.dadosPrestadorService.carregarImagemPerfil().subscribe(
        		data => {
        			this.urlImagemUsuario = this.dadosPrestadorService.getImgPerfilCached();
        			this.usuarioDashboardService.emitIsImagemPerfilAlterada(true);
		  	  		this.messageService.add({severity:'success', summary:'Sucesso alterar imagem do perfil', detail: 'A imagem de perfil foi alterar com sucesso!'});
		          	this.loading = false;
		          	this.modalAlterarImagemPerfil = false;
          		},
          		error => {
          			this.loading = false;
          		}
          	);
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/usuario-dashboard/usuario-dashboard.component.ts